export { default } from 'features/offer/routes/offers-route';
